import { FC, PropsWithChildren, ReactElement } from 'react';

import { Box, Flex, Spinner, StyleProps, useMenuSize } from '@bonusly/design-system';

interface SelectorBoxProps extends PropsWithChildren, StyleProps {
	isLoading?: boolean;
	loadingMessage?: ReactElement | string;
}

export type SelectorProps<T = any> = {
	command: (...args: any[]) => void;
	close: () => void;
	hash: string;
	items: T[];
	isLoading?: boolean;
	query: string;
};

export const SelectorBox: FC<SelectorBoxProps> = ({ children, isLoading = false, loadingMessage, ...rest }) => {
	const ref = useMenuSize();

	return (
		<Box
			className="selector-box"
			bg="bg.surface"
			borderColor="bg.subtle"
			boxShadow="xl"
			border="none"
			borderRadius="lg"
			minW="20rem"
			overflowY="auto"
			p={2}
			ref={ref}
			{...rest}
		>
			<Box>
				{isLoading ? (
					<Flex alignItems="center" direction="column" gap={2} p={4}>
						<Spinner role="status" />
						{loadingMessage}
					</Flex>
				) : (
					children
				)}
			</Box>
		</Box>
	);
};
